const common = {
  // Navbar
  "nav.home": "Strona główna",
  "nav.articles": "Artykuły",
  "nav.comparisons": "Porównania",
  "nav.about": "O nas",
  "nav.contact": "Kontakt",

  // Hero
  "hero.h1": "USFans Spreadsheet — Największa baza twórców i narzędzi dla agencji",
  "hero.subtitle": "Odkryj twórców, analizuj profile i rozwijaj swoją agencję szybciej dzięki USFans Spreadsheet. Kompletny przewodnik 2026.",
  "hero.cta.database": "USFans Spreadsheet",
  "hero.cta.buy": "Kup Teraz",
  "hero.cta.guide": "Przeczytaj poradnik",

  // Categories
  "categories.title": "Przeglądaj kategorie produktów",
  "categories.subtitle": "Wybierz kategorię, aby przejść do pełnej oferty na Kaspreadsheet",
  "categories.select": "Wybierz kategorię...",
  "categories.all": "Wszystkie kategorie",

  // Benefits
  "benefits.title": "Dlaczego USFans Spreadsheet?",
  "benefits.subtitle": "Narzędzie stworzone z myślą o agencjach i twórcach, którzy chcą pracować szybciej i skuteczniej.",
  "benefits.time": "Oszczędność czasu",
  "benefits.time.desc": "Setki przeanalizowanych profili w jednym arkuszu. Koniec z ręcznym researchowaniem.",
  "benefits.research": "Lepszy research",
  "benefits.research.desc": "Dokładne dane analityczne pozwalają podejmować trafniejsze decyzje biznesowe.",
  "benefits.scouting": "Skuteczniejszy scouting",
  "benefits.scouting.desc": "Szybkie wyszukiwanie i filtrowanie twórców według niszy, zasięgów i zaangażowania.",
  "benefits.decisions": "Lepsze decyzje biznesowe",
  "benefits.decisions.desc": "Dane w czasie rzeczywistym pomagają optymalizować kampanie i zwiększać ROI.",

  // Trust
  "trust.title": "Zaufaj sprawdzonemu rozwiązaniu",
  "trust.stat1": "Przeanalizowanych twórców",
  "trust.stat2": "Aktualizacji miesięcznie",
  "trust.stat3": "Kategorii danych",
  "trust.stat4": "Zadowolonych agencji",
  "trust.check1": "Setki analizowanych twórców",
  "trust.check2": "Regularne aktualizacje bazy",
  "trust.check3": "Narzędzia zoptymalizowane dla agencji",
  "trust.check4": "Edukacyjna baza wiedzy",

  // Articles
  "articles.title": "Popularne artykuły i poradniki",
  "articles.subtitle": "Poznaj USFans Spreadsheet od podstaw i wykorzystaj jego pełny potencjał.",
  "articles.read": "Czytaj więcej",
  "articles.article1.title": "USFans Spreadsheet: Kompletny przewodnik 2026",
  "articles.article1.desc": "Wszystko, co musisz wiedzieć o USFans Spreadsheet — od podstaw po zaawansowane strategie dla agencji.",
  "articles.article2.title": "Jak znaleźć twórców szybciej? Praktyczny poradnik",
  "articles.article2.desc": "Poznaj strategie szybkiego scoutingu twórców i dowiedz się, jak USFans Spreadsheet usprawnia ten proces.",
  "articles.article3.title": "USFans Spreadsheet vs ręczny research — porównanie 2026",
  "articles.article3.desc": "Porównujemy efektywność USFans Spreadsheet z tradycyjnym researchowaniem twórców.",

  // FAQ
  "faq.title": "Często zadawane pytania",
  "faq.subtitle": "Odpowiedzi na najczęściej pojawiające się pytania dotyczące USFans Spreadsheet.",
  "faq.q1": "Co to jest USFans Spreadsheet?",
  "faq.a1": "USFans Spreadsheet to kompleksowa baza danych zawierająca szczegółowe informacje o twórcach, analizy profili oraz statystyki zaangażowania. Narzędzie zostało stworzone specjalnie dla agencji marketingowych i osób zarządzających kampaniami z twórcami, aby usprawnić proces researchu i podejmowania decyzji.",
  "faq.q2": "Jak działa baza twórców?",
  "faq.a2": "Baza twórców USFans Spreadsheet działa na zasadzie szczegółowego arkusza kalkulacyjnego, który zawiera setki profili twórców posegregowanych według nisz, zasięgów, wskaźników zaangażowania i innych kluczowych metryk. Dane są regularnie aktualizowane, co zapewnia dostęp do aktualnych informacji.",
  "faq.q3": "Czy dane w USFans Spreadsheet są publiczne?",
  "faq.a3": "Dane zawarte w USFans Spreadsheet pochodzą z publicznie dostępnych profili i są gromadzone zgodnie z regulaminami platform społecznościowych. Arkusz agreguje i organizuje te informacje w użyteczny format, oszczędzając godziny ręcznego researchu.",
  "faq.q4": "Jak korzystać z arkusza USFans Spreadsheet?",
  "faq.a4": "Arkusz jest intuicyjny i gotowy do użycia od razu po zakupie. Możesz filtrować twórców według kategorii, sortować według metryk i eksportować dane do własnych narzędzi. Pełna instrukcja znajduje się w naszym poradniku.",
  "faq.q5": "Czy USFans Spreadsheet jest bezpieczny?",
  "faq.a5": "Tak, USFans Spreadsheet wykorzystuje wyłącznie publicznie dostępne dane i nie narusza żadnych regulaminów. Wszystkie informacje są gromadzone i prezentowane w sposób zgodny z obowiązującymi przepisami o ochronie danych i regulaminami platform.",

  // Footer
  "footer.description": "USFans Wiki to polska baza wiedzy o USFans Spreadsheet — narzędziu do analizy twórców i zarządzania kampaniami dla agencji.",
  "footer.quickLinks": "Szybkie linki",
  "footer.resources": "Zasoby",
  "footer.copyright": "© 2026 USFans Wiki. Wszelkie prawa zastrzeżone.",
  "footer.privacy": "Polityka prywatności",
  "footer.terms": "Regulamin",

  // Article page
  "article.back": "← Powrót do strony głównej",
  "article.breadcrumb.home": "Strona główna",
  "article.breadcrumb.articles": "Artykuły",
  "article.related": "Powiązane artykuły",
  "article.share": "Udostępnij",
  "article.updated": "Ostatnia aktualizacja",
  "article.readTime": "Czas czytania",

  // Common
  "common.external": "Link zewnętrzny",
  "common.learnMore": "Dowiedz się więcej",
};

export default common;